import { ScreenDesignSpecification } from "../screenDesignSpecification.ts";

/**
 * No theme: a screen with nothing to say about one inherits its file's.
 * Stating `builtin:default` here would pin every default-constructed screen
 * and quietly opt it out of the file it lands in.
 */
export const defaultScreenDesignSpecification: ScreenDesignSpecification = {
  screenType: "desktop-medium",
};
